<div style="height: 100%; width: 100%; position: absolute">
  <mat-drawer-container class="right-nav">
    <mat-drawer class="right-nav" #drawer [mode]="'over'" position="end">
      <mat-toolbar> Global Navigation </mat-toolbar>
      <div class="navigation-options" (click)="drawer.toggle()">
        <mat-action-list>
          <button mat-list-item data-qa-id="nav-btn-home" class="mat-primary" [routerLinkActiveOptions]="{ exact: true }" routerLink="/"
            routerLinkActive="active">
            <mat-icon>home</mat-icon><span>Home</span>
          </button>

          @if (hasPermission(permissions.userGroupAdmin)) {
            <button mat-list-item data-qa-id="nav-btn-feature-management" class="mat-primary" routerLink="/feature/management" routerLinkActive="active">
              <mat-icon>extension</mat-icon><span>Feature Management</span>
            </button>
          }

          <button mat-list-item data-qa-id="nav-btn-environments" class="mat-primary" routerLink="/environments" routerLinkActive="active">
            <mat-icon>settings_input_hdmi</mat-icon><span>Environments</span>
          </button>

          <button mat-list-item data-qa-id="nav-btn-localisation" class="mat-primary" routerLink="/localisation" routerLinkActive="active">
            <mat-icon>language</mat-icon><span>Localisation</span>
          </button>

          <button mat-list-item data-qa-id="nav-btn-jobs" class="mat-primary" routerLink="/jobs" routerLinkActive="active">
            <mat-icon>playlist_play</mat-icon><span>Jobs</span>
          </button>
          <button mat-list-item data-qa-id="nav-btn-feature-testing" class="mat-primary" routerLink="/feature-testing" routerLinkActive="active">
            <mat-icon>difference</mat-icon><span>Feature Testing</span>
          </button>

          @if (hasPermission(permissions.migrationTool)) {
            <button mat-list-item data-qa-id="nav-btn-maintenance-task-scheduler" class="mat-primary" routerLink="/maintenancetaskscheduler" routerLinkActive="active">
              <mat-icon>schedule</mat-icon><span>Maintenance Task Scheduler</span>
            </button>
          }
        </mat-action-list>
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <mat-toolbar class="mat-primary">
        <span>
          <a data-qa-id="toolbar-btn-home" mat-raised-button class="mat-accent tableBtn" routerLink="/" routerLinkActive="active">
            <mat-icon>home</mat-icon>
          </a>
        </span>
        <span>
          <mat-select data-qa-id="toolbar-select-tenant" placeholder="Select a tenant" class="mat-primary aw-select" [(ngModel)]="selectedTenant"
            (selectionChange)="onSelect()" (openedChange)="filterInput.focus()" (closed)="onDropdownClosed(filterInput)">
            <div class="aw-select-filter">
              <input #filterInput (keyup)="filterTenants(filterInput.value)"
                (keydown.space)="$event.stopPropagation()" type="text" placeholder="Filter Tenants"
                autocomplete="off" />
            </div>
            @if (filteredTenants.length === 0) {
              <mat-option disabled="true">No results</mat-option>
            }
            @for (tenant of filteredTenants; track tenant.TenantId) {
              <mat-option
                class="multiline-mat-option"
                [class.selected]="tenant === tenantService.selectedTenant"
                [class.disabled]="!tenant.HasAccess"
                [value]="tenant"
                (click)="filterInput.value = ''"
              >
                  <div>{{ tenant.Text || tenant.Value }}</div>
                  <div class="mat-caption">@if (tenant.CrmName) { <span> // {{tenant.CrmName}}</span> }</div>
              </mat-option>
            }
          </mat-select>
          <a data-qa-id="toolbar-btn-refresh-tenants" mat-raised-button class="mat-accent tableBtn refresh-tenants" (click)="loadTenants()">
            <mat-icon>refresh</mat-icon>
          </a>
          @if (selectedTenantHasAirswebApplication) {
            <a data-qa-id="toolbar-btn-access-ehs" mat-raised-button class="mat-accent access-btn" (click)="accessAva()">
              <mat-icon>link</mat-icon> Access EHS
            </a>
          }
          <a data-qa-id="toolbar-btn-new-tenant" mat-raised-button class="mat-accent new-tenant" routerLink="/newtenant" routerLinkActive="active">
            <mat-icon>add</mat-icon> New Tenant
          </a>
          @if (tenantTypeDisplayName && tenantService.selectedTenant) {
            <span class="tenant-type" [ngClass]="tenantTypeDisplayName">{{ tenantTypeDisplayName }}</span>
          }
          <span class="tenant-status" [ngClass]="tenantStatus">{{
            tenantStatus
          }}</span>
        </span>
        <span class="spacer"></span>
        <button data-qa-id="toolbar-btn-menu-toggle" mat-icon-button (click)="drawer.toggle()">
          <mat-icon class="global-navigation-button">menu</mat-icon>
        </button>
      </mat-toolbar>

      <router-outlet></router-outlet>
      <aw-toast></aw-toast>
    </mat-drawer-content>
  </mat-drawer-container>
  <div>
    <!--Footer-->
  </div>
</div>